import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AlertasPagina } from './pages/Alertas';
import { ConfiguracionAlertasPagina } from './pages/ConfiguracionAlertas';
import { FlotaPagina } from './pages/Flota';
import { JornadasPagina } from './pages/Jornadas';
import { LoginPagina } from './pages/Login';
import { ReportesPagina } from './pages/Reportes';
import { TorrePagina } from './pages/Torre';
import { TroncalDetallePagina } from './pages/TroncalDetalle';
import { TroncalesPagina } from './pages/Troncales';
import { ViajeDetallePagina } from './pages/ViajeDetalle';
import { ViajesPagina } from './pages/Viajes';
import { SesionProvider } from './state/Sesion';
import { TemaProvider } from './state/Tema';
import { ToastProvider } from './state/Toast';

export default function App() {
  return (
    <TemaProvider>
      <ToastProvider>
        <SesionProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
              <Route path="/login" element={<LoginPagina />} />
              <Route element={<Layout />}>
                <Route index element={<TorrePagina />} />
                <Route path="viajes" element={<ViajesPagina />} />
                <Route path="viajes/:id" element={<ViajeDetallePagina />} />
                <Route path="troncales" element={<TroncalesPagina />} />
                <Route path="troncales/:id" element={<TroncalDetallePagina />} />
                <Route path="configuracion/alertas" element={<ConfiguracionAlertasPagina />} />
                <Route path="alertas" element={<AlertasPagina />} />
                <Route path="jornadas" element={<JornadasPagina />} />
                <Route path="flota" element={<FlotaPagina />} />
                <Route path="reportes" element={<ReportesPagina />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </SesionProvider>
      </ToastProvider>
    </TemaProvider>
  );
}
